import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from './Icon';
import { faMinus, faPlus, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '../lib/i18n';

export function Crumbs({ items }) {
  const { t } = useI18n();
  return (
    <nav className="mb-1.5 flex flex-wrap items-center gap-2 text-[13px] text-slate-500" aria-label={t('Breadcrumb')}>
      {items.map(([label, to], i) => (
        <span key={label} className="flex items-center gap-2">
          {i > 0 && <FontAwesomeIcon icon={faChevronRight} className="text-[9px] text-slate-400" />}
          {to ? <Link to={to} className="hover:text-brand-600">{label}</Link> : <span>{label}</span>}
        </span>
      ))}
    </nav>
  );
}

export function PageHead({ title, crumbs, children }) {
  return (
    <div className="border-b border-slate-200 bg-soft py-7">
      <div className="shell">
        {crumbs && <Crumbs items={crumbs} />}
        <h1 className="text-[28px] font-extrabold sm:text-[32px]">{title}</h1>
        {children}
      </div>
    </div>
  );
}

export function SectionHead({ title, subtitle, action }) {
  return (
    <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h2 className="text-[26px] font-extrabold sm:text-3xl">{title}</h2>
        {subtitle && <p className="mt-1.5 text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Empty({ children, className = '' }) {
  return <div className={`rounded-2xl border border-dashed border-slate-300 px-5 py-14 text-center text-slate-500 ${className}`}>{children}</div>;
}

export function QtyInput({ value, onChange, max = 999, min = 1 }) {
  const { t } = useI18n();
  const set = (v) => onChange(Math.max(min, Math.min(max || min, Math.floor(Number(v)) || min)));
  return (
    <div className="inline-flex overflow-hidden rounded-xl border border-slate-200">
      <button type="button" onClick={() => set(value - 1)} disabled={value <= min} aria-label={t('Decrease')}
        className="w-10 cursor-pointer bg-soft text-sm text-slate-600 hover:text-brand-600 disabled:opacity-40"><FontAwesomeIcon icon={faMinus} /></button>
      <input type="number" value={value} min={min} max={max} onChange={(e) => set(e.target.value)} aria-label={t('Quantity')}
        className="w-12 [appearance:textfield] py-2 text-center font-semibold outline-none [&::-webkit-inner-spin-button]:appearance-none" />
      <button type="button" onClick={() => set(value + 1)} disabled={value >= max} aria-label={t('Increase')}
        className="w-10 cursor-pointer bg-soft text-sm text-slate-600 hover:text-brand-600 disabled:opacity-40"><FontAwesomeIcon icon={faPlus} /></button>
    </div>
  );
}

export function Field({ label, htmlFor, hint, className = '', children }) {
  return (
    <div className={className}>
      {label && <label className="label" htmlFor={htmlFor}>{label}</label>}
      {children}
      {hint && <span className="hint">{hint}</span>}
    </div>
  );
}
